import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';

const App = () => {
  return (
    <div className="text-white font-sans min-h-screen flex flex-col" style={{ backgroundColor: '#140f0d' }}>
      <Header />
      <main className="flex flex-col text-left w-full max-w-4xl mx-auto px-2 md:px-6 pb-12 md:pb-12">
        <Hero />
      </main>
      <Footer />
    </div>
  );
};

export default App; 